import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import PreCertLinkBanner from "./Shared/Components/PreCertLinkBanner";

export default function NotFoundPage() {
    return (
        <header>
               <PreCertLinkBanner/>
            <Container>
                <h1>The page you are looking for could not be found.</h1>
                <p>If you are using a bookmark from your browser to navigate to preCERT, you may need to update your bookmark.</p>
                <p><Link to="/">Return to the Active Roster</Link></p>
            </Container>
        </header>
    );
}